import styled from "styled-components";
import { SectionTitle } from "./shared";
import { SkillProjectsPopup, useSkillProjects } from '../../../components/skill-projects-popup';

// Styled Components
const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 6rem auto 0;
  padding: 0 2rem;
  position: relative;
`;


const TechGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const TechBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-weight: 500;
  font-size: 0.875rem;
  background-color: rgba(59, 130, 246, 0.1);
  color: #60a5fa;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(59, 130, 246, 0.2);
    transform: translateY(-2px);
  }
`;

const Skills3 = ({ skills }) => {
  const { selectedSkill, isPopupVisible, handleSkillClick, handleClosePopup } = useSkillProjects();

  if (!skills || skills.length === 0) return null;

  return (
    <>
      <Container id="projects">
        <SectionTitle>Technical Expertise</SectionTitle>
        <TechGrid>
          {skills.map((tech) => (
            <TechBadge
              key={tech.id}
              onClick={() => handleSkillClick(tech)}
            >
              {tech.name}
            </TechBadge>
          ))}
        </TechGrid>
      </Container>
      
      <SkillProjectsPopup
        visible={isPopupVisible}
        onHide={handleClosePopup}
        skill={selectedSkill}
      />
    </>
  );
};

export default Skills3;
